import { render, staticRenderFns } from "./modal_atender_recepcao.vue?vue&type=template&id=be3b08e2&scoped=true"
import script from "./modal_atender_recepcao.vue?vue&type=script&lang=js"
export * from "./modal_atender_recepcao.vue?vue&type=script&lang=js"
import style0 from "./modal_atender_recepcao.vue?vue&type=style&index=0&id=be3b08e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3b08e2",
  null
  
)

export default component.exports